import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=5d5c3c0e&scoped=true&"
var script = {}
import style0 from "./Application.vue?vue&type=style&index=0&id=5d5c3c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c3c0e",
  null
  
)

export default component.exports